import { useAppDispatch, useAppSelector } from "index";

import { styled, alpha } from "@mui/material/styles";
import Button from "@mui/material/Button";
import { Clear, Search as SearchIcon } from "@mui/icons-material";
import Box from "@mui/material/Box";
import Tooltip from "@mui/material/Tooltip";
import InputBase from "@mui/material/InputBase";
import { ApplicationState } from "store/index";
import { search } from "store/options/actions";
import useLanguageHook from "containers/hooks/useLanguageHook";
import { InputAdornment } from "@mui/material";

const SearchIconWrapper = styled("div")(({ theme }) => ({
  padding: theme.spacing(0, 2),
  height: "100%",
  position: "absolute",
  pointerEvents: "none",
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
}));

const Search = styled("div")(({ theme }) => ({
  position: "relative",
  borderRadius: theme.shape.borderRadius,
  backgroundColor: alpha(theme.palette.common.white, 0.15),
  "&:hover": {
    backgroundColor: alpha(theme.palette.common.white, 0.25),
  },
  marginLeft: 0,
  width: "100%",
  [theme.breakpoints.up("sm")]: {
    marginLeft: theme.spacing(1),
    width: "auto",
  },
}));

const StyledInputBase = styled(InputBase)(({ theme }) => ({
  color: "inherit",
  "& .MuiInputBase-input": {
    padding: theme.spacing(1, 1, 1, 0),
    // vertical padding + font size from searchIcon
    paddingLeft: `calc(1em + ${theme.spacing(4)})`,
    transition: theme.transitions.create("width"),
    width: "100%",
    [theme.breakpoints.up("sm")]: {
      width: "12ch",
      "&:focus": {
        width: "20ch",
      },
    },
  },
}));

function SearchField() {
  const searchString = useAppSelector((state: ApplicationState) => state.options.searchString);
  const dispatch = useAppDispatch();
  const { t } = useLanguageHook();

  return (
    <Box>
      <Search>
        <SearchIconWrapper>
          <SearchIcon />
        </SearchIconWrapper>
        <StyledInputBase
          value={searchString}
          placeholder={t.Vis.Search}
          inputProps={{ "aria-label": t.Vis.Search }}
          onChange={(d) => dispatch(search(d.target.value))}
          endAdornment={
            <InputAdornment position="start">
              <Tooltip title={t.Vis.ClearSearch}>
                <Button onClick={() => dispatch(search(""))}>
                  <Clear />
                </Button>
              </Tooltip>
            </InputAdornment>
          }
        />
      </Search>
    </Box>
  );
}

export default SearchField;
